var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJpg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_832_2464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0.5C4.3125 0.5 3.75 1.0625 3.75 1.75V19.25C3.75 19.9375 4.3125 20.5 5 20.5H17.5C18.1875 20.5 18.75 19.9375 18.75 19.25V5.5L13.75 0.5H5Z",
    fill: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5.5H18.75L13.75 0.5V4.25C13.75 4.9375 14.3125 5.5 15 5.5Z",
    fill: "#B0B7BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 9.25L15 5.5H18.75V9.25Z",
    fill: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 16.75C16.25 17.0938 15.9688 17.375 15.625 17.375H1.875C1.53125 17.375 1.25 17.0938 1.25 16.75V10.5C1.25 10.1562 1.53125 9.875 1.875 9.875H15.625C15.9688 9.875 16.25 10.1562 16.25 10.5V16.75Z",
    fill: "#50BEE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54563 12.3419C5.54563 11.9219 6.20563 11.9219 6.20563 12.3419V14.3156C6.20563 15.1006 5.83063 15.5756 4.96626 15.5756C4.54126 15.5756 4.18688 15.46 3.87688 15.0606C3.62188 14.7556 4.10188 14.3162 4.36188 14.6356C4.57188 14.8956 4.79688 14.9556 5.01626 14.9456C5.29563 14.9356 5.54126 14.81 5.54626 14.3156V12.3419H5.54563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08374 12.3419C7.08374 12.1769 7.21374 11.9969 7.42374 11.9969H8.57812C9.22812 11.9969 9.81312 12.4319 9.81312 13.2656C9.81312 14.0556 9.22812 14.4956 8.57812 14.4956H7.74374V15.1556C7.74374 15.3756 7.60374 15.5 7.42374 15.5C7.25874 15.5 7.08374 15.3756 7.08374 15.1556V12.3419ZM7.74374 12.6262V13.8712H8.57812C8.91312 13.8712 9.17812 13.5756 9.17812 13.2656C9.17812 12.9162 8.91312 12.6262 8.57812 12.6262H7.74374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3819 15.1156C13.0269 15.4106 12.5919 15.5356 12.1525 15.5356C11.1025 15.5356 10.3582 14.9362 10.3582 13.7462C10.3582 12.7375 11.1432 11.9531 12.1969 11.9531C12.5919 11.9531 13.0263 12.0875 13.3363 12.3925C13.6407 12.6919 13.2013 13.1369 12.9019 12.8725C12.7169 12.6925 12.4569 12.5575 12.1969 12.5575C11.5925 12.5575 11.0082 13.0419 11.0082 13.7462C11.0082 14.4862 11.4975 14.9362 12.1525 14.9362C12.4569 14.9362 12.7169 14.8456 12.9019 14.7113V14.0969H12.1525C11.7075 14.0969 11.7525 13.4869 12.1525 13.4869H13.1519C13.3369 13.4869 13.5063 13.6269 13.5063 13.7819V14.8463C13.5063 14.9363 13.4669 15.02 13.3819 15.1156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.625 17.375H3.75V18H15.625C15.9688 18 16.25 17.7188 16.25 17.375V16.75C16.25 17.0938 15.9688 17.375 15.625 17.375Z",
    fill: "#CAD1D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_832_2464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/JPG.fe69cea5cac112088733d9352cd85e50.svg";
export { ForwardRef as ReactComponent };